import { useLayers } from '@agissc/ktag-map';
import { useMetadataQuery } from '../../api/useMetadataQuery';

export const useHasAttributeSearch = (
  topicLayerId: string,
): { isLoading: boolean; hasAttributeSearch?: boolean } => {
  const layersQuery = useLayers();
  const metadataQuery = useMetadataQuery(topicLayerId);

  if (layersQuery.isLoading) return { isLoading: true };
  if (metadataQuery.isLoading) return { isLoading: true };

  return {
    isLoading: false,
    hasAttributeSearch:
      metadataQuery.data &&
      Object.values(metadataQuery.data).some(
        (layer) =>
          layer.attributeSearchAllowed && layer?.searchableAttributes?.length > 0,
      ) === true,
  };
};
